<template>
  <div id="home" class="n5-inicio" ref="raiz">
    <!-- Mismo orden y mismos interruptores que la portada de siempre (panel: Inicio) -->
    <N5Portada />
    <N5Notario />
    <N5Servicios />
    <N5Blog />
    <N5Llamada />
    <N5Testimonios />
    <N5Galeria />
    <N2Faq />
    <N2Contacto />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAparicion } from '../../composables/useNotaria2'
import N5Portada from './N5Portada.vue'
import N5Notario from './N5Notario.vue'
import N5Servicios from './N5Servicios.vue'
import N5Blog from './N5Blog.vue'
import N5Llamada from './N5Llamada.vue'
import N5Testimonios from './N5Testimonios.vue'
import N5Galeria from './N5Galeria.vue'
import N2Faq from '../notaria2/N2Faq.vue'
import N2Contacto from '../notaria2/N2Contacto.vue'

const raiz = ref(null)
useAparicion(raiz)
</script>
